export function cdnEndpoints(cdnBaseUrl: string) {
  const portalPasUrl = cdnBaseUrl + 'portalpas/';
  const commonImages = cdnBaseUrl + 'common/images/';
  return {
    base: cdnBaseUrl,
    insuranceLogoNegative: `${commonImages}seguros/logo-seguros-negativo-386x78.svg`,
    scLogo: `${commonImages}grupo-san-cristobal/logo-iso-sancristobal-negativo.svg`,
    gscLogoGreenNegative: `${commonImages}grupo-san-cristobal/logo-gsc-negativo-verde-151x52.svg`,
    geoPoint: `${commonImages}localizacion.svg`,
    successImage: `${portalPasUrl}common/caso-exito.svg`,
    insuranceLogo: `${commonImages}seguros/logo-seguros-366x74.svg`,
    insuranceNegativeLogo: `${commonImages}seguros/logo-seguros-negativo-386x78.svg`,
    retirementLogo: `${commonImages}retiro/logo-retiro-313x60.svg`,
    financialServicesLogo: `${commonImages}servicios-financieros/logo-servicios-financieros-313x58.svg`,
    mapsImages: `${commonImages}maps/`,
    insuranceLogoPrintable: '/assets/images/logo-sc-printable.svg',
    portalPas: portalPasUrl,
    agro: portalPasUrl + 'agro',
    marketingDigital: portalPasUrl + 'marketing-digital',
    requestQuote: portalPasUrl + 'request-quote',
    scNegativeLogo: `${commonImages}grupo-san-cristobal/logo-iso-sancristobal-negativo.svg`,
    collectiveLife: portalPasUrl + 'collective-life',
    common: portalPasUrl + 'common',
    contentManager: `${cdnBaseUrl}content-manager`,
    commonImages: `${cdnBaseUrl}common/images`,
    loading: `${commonImages}loading.gif`,
    loadingError: `${commonImages}error-al-cargar.svg`,
    emptyFolder: `${commonImages}vacio.svg`,
    iconMultiField: `${commonImages}maps/icon-multi-fields.png`,
    iconOneField: `${commonImages}maps/icon-one-field.png`,
    add: `${portalPasUrl}common/agregar.svg`,
    warningModal: `${portalPasUrl}common/modal-de-warning.svg`,
    modalSuccess: `${commonImages}modal-de-exito.svg`,
    modalWarning: `${portalPasUrl}common/modal-warning.svg`,
    modalSearchGlass: `${portalPasUrl}common/modal-search-glass.svg`,
    modalError: `${commonImages}modal-de-error.svg`,
    house: `${commonImages}house.svg`,
    pageInMaintenance: `${commonImages}pagina-en-mantenimiento.svg`,
    errorCase: `${commonImages}caso-de-error.svg`,
    successCase: `${commonImages}caso-de-exito.svg`,
    notFound: `${commonImages}no-se-encuentra.svg`,
    warning: `${commonImages}warning.svg`,
    applause: `${commonImages}aplauso.svg`,
    assistance24: `${commonImages}24hs.svg`,
    help2: `${commonImages}ayuda-2.svg`,
    help1: `${commonImages}ayuda-1.svg`,
    legal: `${commonImages}legal.svg`,
    doctor: `${commonImages}doctora.svg`,
    notebookNeutral: `${commonImages}notebook-neutral.svg`,
    carFront: `${commonImages}auto-adelante.svg`,
    carBack: `${commonImages}auto-atras.svg`,
    carRight: `${commonImages}auto-lateral-der.svg`,
    carLeft: `${commonImages}auto-lateral-izq.svg`,
    chrome: `${commonImages}chrome.svg`,
    backgroundDark: `${commonImages}background-dark.svg`,
    backgroundLight: `${commonImages}background-light.svg`,
    legalSsnPdpAfip: `${commonImages}banner-legales-ssn-pdp-afip.svg`,
    unplugged: `${commonImages}plataforma-caida.svg`,
    vehicleIdentificationCard: `${commonImages}cedula.svg`,
    pay: `${commonImages}pagar.svg`,
    inspection: `${commonImages}inspeccion.svg`,
    tireDetail: `${commonImages}tire-detail.svg`,
    notebook: `${commonImages}notebook.svg`,
    personWithComputer: `${commonImages}computadora-sonriente.svg`,
    expiredTime: `${commonImages}tiempo-expirado.svg`,
    inRevision: `${commonImages}buscador-de-polizas.svg`,
    financeGraph: `${commonImages}finanzas-2.svg`,
    security: `${commonImages}seguridad.svg`,
    mail: `${commonImages}mail.svg`,
    shapeBackground: `${commonImages}forma-6.svg`,
  };
}